import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center",
  role: "alert"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "Die Meldung konnte leider nicht übermittelt werden. Bitte prüfen Sie Ihre Eingaben nochmal.", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Hinweis: Meldende sind bereits automatisch für ihre eigenen Meldungen abonniert. ")
const _hoisted_4 = {
  id: "wdw-filter-form",
  class: "wdw-form mt-4"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("   ")

import messageRepository from '@/api/messageRepository';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
// import FormControlInput from '@/components/general/FormControl/Input.vue';
// eslint-disable-next-line
//@ts-ignore
import { Input as FormControlInput } from 'wdw-library/dist/esm/Input';
import { Form } from 'vee-validate';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: { messageid: { type: Number, required: true } },
  emits: ['cancel', 'submit'],
  setup(__props, { emit }) {

const props = __props




const subscribeFail = ref(false);
const submitting = ref(false);
function closeDialog() {
  emit('cancel');
}
function submitSubscribe(values: any, { resetForm }: any) {
  submitting.value = true;
  messageRepository
    .subscribeMessage(props.messageid, values)
    .then(() => {
      emit('submit');
      resetForm();
    })
    .catch(() => {
      subscribeFail.value = true;
    })
    .finally(() => {
      submitting.value = false;
    });
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (subscribeFail.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: "x",
            class: "flex-shrink-0 me-2"
          }),
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode(WdwDynbox, {
      title: `BENACHRICHTIGUNGEN ZU MELDUNG ${__props.messageid} ABONNIEREN`,
      config: { showControls: false },
      minimize: false
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createVNode(_unref(Form), { onSubmit: submitSubscribe }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(FormControlInput), {
                additionalLabelClasses: 'wdw-filter-label',
                label: "E-Mail-Adresse, an die Benachrichtigungen verschickt werden sollen",
                type: "email",
                name: "email",
                required: true
              })
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-default btn-form-cancel",
              onClick: closeDialog
            }, "Abbrechen"),
            _createElementVNode("button", {
              disabled: submitting.value,
              class: "btn btn-success btn-form-submit btn-submit-filter",
              type: "submit"
            }, " Speichern ", 8, _hoisted_5),
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}
}

})